export const translationIT = {
    policyMessage: "Utilizzando FeedInApp acconsenti alle nostre <Anchor>Privacy Policy</Anchor> che includono l'utilizzo di cookies.",
    acceptButton: "Accetto",
    loading: "Caricamento del menù in corso...",
    loadingText: "FeedInApp®",
    noDescAvail: "Descrizione non disponibile",
    vegetarianBadge: "Vegetariano",
    veganBadge: "Vegano",
    glutenFreeBadge: "Senza Glutine",
    notGlutenFreeBadge: "Contiene Glutine",
    frozenBadge: "Surgelato",
    closeModal: "Chiudi",
    allergens: "Allergeni:",
    contactUs: "Contattaci",
    estimateCheck: "Stima il conto",
    priceModal: "Prezzo:",
    emptyCart: "Svuota",
    cartPriceWarning: "*Il prezzo indicato è solo una stima. Non tiene conto di prezzi al kg o al litro ed eventuali costi di coperto del ristorante.",
    whenOpen: "Quando siamo aperti",
    open: "Ora aperto",
    closed: "Ora chiuso",
    mon: "Lunedì",
    tue: "Martedì",
    wed: 'Mercoledì',
    thu: 'Giovedì',
    fri: 'Venerdì',
    sat: 'Sabato',
    sun: 'Domenica',
    callUs: "Chiamaci",
    website: "Sito web",
    ourEvents: "I nostri eventi",
    daysAgo: "giorni fa",
    hoursAgo: "ore fa",
    minutesAgo: "minuti fa",
    coverChargeIn: "Coperto dentro",
    coverChargeOut: "Coperto fuori", 
    whoops: "oops...",
    notFoundMsg: "Ci dispiace, non abbiamo trovato quello che cercavi.",
    review_us_modal_support_business: "Sostieni la nostra attività",
    review_us_modal_headline: "RECENSISCICI SU GOOGLE",
    review_us_modal_subheadline: "La tua opinione ci aiuta a raggiungere molte più persone! Se i nostri prodotti o servizi hanno fatto colpo su di te, lascia una valutazione!",
    review_us_modal_button_text: "Recensisci con Google",
    review_us_modal_greeting_text: "Regalaci un sorriso lasciando una recensione con 5 stelle su",
    menu_modal_loading_text: "Caricamento immagine in corso...",
    modal_wine_designations: "Denominazioni:",
    modal_wine_gastronomic_matches: "Abbinamenti gastronomici:",
    modal_wine_technicalities: "Scheda tecnica:",
}